import ReactGA from 'react-ga4'

const initializeGA = (): any => {
  if (process.env.NODE_ENV !== 'production') return

  const gaMeasurementId = process.env.REACT_APP_GA_MEASUREMENT_ID || ''
  if (gaMeasurementId) ReactGA.initialize(gaMeasurementId)
}

const logPageView = (): any => {
  ReactGA.send({ hitType: 'pageview', page: window.location.pathname })
}

export { initializeGA, logPageView }
